// Coverage record card. Mirrors data-component="coverage-record" (unnamed
// container in HTML; the Record card holds horse identity + the three
// status pillars). Visually matches the amber "Needs information" treatment.
//
// TODO(runtime): hydrate from services/customer-coverage.getCoverageState(
//   relationshipId) + dist/account-workflows.applications once the HTTP read
//   endpoint lands. Field order: application / subscription / coverage.
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';
import type { CoverageHorse } from '../mockData.js';

export interface CoverageRecordProps {
  horse: CoverageHorse;
  onViewHorseProfile?: () => void;
}

export function CoverageRecord({ horse, onViewHorseProfile }: CoverageRecordProps): ReactNode {
  return (
    <section className="card coverage-record" aria-label="Duke coverage record">
      <div className="card-head">
        <div className="row">
          <span className="head-icon">
            <Icon id="horse" />
          </span>
          <h3>{horse.name}'s coverage record</h3>
        </div>
        <span className="amber-status">{horse.applicationStatus}</span>
      </div>
      <div className="coverage-body">
        <div className="coverage-horse">
          <div className="horse-avatar">
            <Icon id="horse" />
          </div>
          <div>
            <h2>{horse.name}</h2>
            <p>
              {horse.breed} &middot; {horse.discipline}
            </p>
            <small>Sarah Mitchell &middot; Individual horse record</small>
          </div>
          <button
            className="outlined"
            type="button"
            onClick={onViewHorseProfile}
          >
            View horse profile
          </button>
        </div>
        <div className="coverage-statuses">
          <div>
            <span>APPLICATION</span>
            <strong className="amber-text">{horse.applicationStatus}</strong>
            <small>Review missing details below</small>
          </div>
          <div>
            <span>SUBSCRIPTION</span>
            <strong>{horse.subscriptionStatus}</strong>
            <small>{horse.subscriptionNote}</small>
          </div>
          <div>
            <span>COVERAGE</span>
            <strong className="amber-text">{horse.coverageStatus}</strong>
            <small>Written acceptance not recorded</small>
          </div>
        </div>
        <div className="coverage-callout">
          <Icon id="help" />
          <div>
            <strong>A purchase does not confirm coverage.</strong>
            <p>
              Application, subscription, written acceptance and active coverage are separate records.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
